import {Alert} from "@mantine/core";
import {PlatformLoader} from "@flexinet/ui-components";
import {useAllowedActions} from "../../../hooks/useAllowedActions.ts";
import {PortalDashboard} from "../components/PortalDashboard.tsx";
import {useAuth} from "../../../hooks/useAuth.ts";

export const IndexPage = () => {
    const {user} = useAuth();
    const {allowedActions, authorizing, status} = useAllowedActions();

    // FNP-1932: the menu hides the dashboard without ViewDashboard; the page
    // checks it too, so a typed URL cannot reach it. allowedActions is empty
    // until the check settles, so hold rather than deny on a guess.
    if (!user || authorizing) {
        return <PlatformLoader message="Loading dashboard...Please wait!"/>;
    }

    if (status === 'failed') {
        return <Alert color='red' title="Couldn't check your permissions"/>;
    }

    // No redirect: `/` sends a signed-in user back here, which would loop.
    if (!allowedActions.includes('ViewDashboard')) {
        return <Alert color='yellow' title='You are not allowed to view the dashboard'/>;
    }

    return <PortalDashboard/>;
};
